import { ReactElement } from 'react';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { Col } from 'newcomponents/UI/Col';
import { Row } from 'newcomponents/UI/Row';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

type Props = {
  competition?: boolean;
  isLive?: boolean;
  noTitle?: boolean;
  withMarketFilter?: boolean;
  withPadding?: boolean;
};

export const HeaderPickerSkeleton = (props: Props): ReactElement => {
  return (
    <>
      <div
        className={cc([
          'header-picker-container',
          {
            'header-picker-container--live': props.isLive,
            'header-picker-container--padding': props.withPadding
          }
        ])}
      >
        {!props.noTitle ? (
          <div className="header-title game-name">
            <Skeleton
              title={{ style: { width: 100, margin: 0, height: 14 } }}
              paragraph={false}
              active
            />
          </div>
        ) : null}
        {!props.isLive && (
          <div className="header-title picker">
            {props.competition || props.withMarketFilter ? (
              <Skeleton
                title={{ style: { width: 100, margin: 0, height: 14 } }}
                paragraph={false}
                active
              />
            ) : (
              <Skeleton
                title={{
                  style: {
                    width: 60,
                    margin: 0,
                    height: 32
                  }
                }}
                paragraph={false}
                active
              />
            )}
          </div>
        )}
      </div>
      {props.competition && isMobile() && (
        <Row
          wrap={false}
          style={{
            padding: 12,
            background: 'var(--v3-black-0)'
          }}
        >
          <Col flex="auto">
            <Skeleton
              title={{
                style: {
                  marginTop: 0,
                  marginBottom: 0,
                  width: 150
                }
              }}
              paragraph={false}
              active
            />
          </Col>
        </Row>
      )}
    </>
  );
};
